<template>
    <lazy-component>
        <div class="data-container">
            <div class="data-el shadow r8">
                <div class="bh bstart title-el">
                    <div class="b1 fz_36 fwb c_222">{{title}}</div>
                    <van-button class="btn btn-text" @click.stop="onMoreClick(data)">
                        <div class="bh bstart">
                            <div class="fz_28 c_666 more">查看更多</div>
                            <div class="ico-next bg-contain"></div>
                        </div>
                    </van-button>
                </div>
                <div class="swiper-container">
                    <zbSwiper
                        :data="store.data"
                        :options="options"
                        designWidth="218"
                        :show-indicators="false"
                        v-slot:default="{ item }"
                    >
                        <div
                            class="item"
                            @click="go('CarGoodsInfo',{
                       id: item.id
                    })"
                        >
                            <div class="item-el r8 shadow">
                                <div class="img bg-100" v-lazy:background-image="item.smallPic" />
                                <div class="fz_22 c_222 title overflow2 breakword">{{item.name}}</div>
                                <div class="bh bstart content">
                                    <div class="ico-maintenance bg-contain"></div>
                                    <div class="fz_28 c_error b1">&ensp;{{item.price}}</div>
                                    <s class="fz_24 c_999">￥{{item.originalPrice}}</s>
                                </div>
                            </div>
                        </div>
                    </zbSwiper>
                </div>
            </div>
        </div>
    </lazy-component>
</template>

<script>
import zbSwiper from "@/components/swiper/Container.vue";
import { goodList } from "@/api/car";
import { list } from "@/mixin/list";
export default {
    mixins: [list],
    name: "CarGoodsSwiper",
    components: { zbSwiper },
    props: {
        // store 数据源
        data: {
            type: Object
        }
    },
    data() {
        return {
            options: {
                loop: false
            },
            title: "",
            store: {
                proxy: {
                    getList: goodList
                }
            }
        };
    },
    watch: {
        data: {
            handler({ name, id }) {
                this.title = name;
                this.storeLoad({ goodsCategoryId: id, name });
            },
            immediate: true
        }
    },
    // mounted() {
    //     console.log('mounted')
    // },
    methods: {
        onMoreClick(data) {
            // 抛出事件
            this.$store.state.queryParams = { id: data.id, name: data.name };
            this.go("CarGoodsHome");
        }
    }
};
</script>

<style scoped lang="scss">
.data-container {
    padding: 24px 24px 0 24px;
    .data-el {
        background-color: #fff;
        padding: 40px 0;
    }
    .swiper-container {
        padding-left: 15px;
    }
}
.title-el {
    padding: 0 20px 30px 20px;
    .ico-next {
        width: 15px;
        height: 26px;
        margin: 0 0 5px 11px;
    }
}
.item {
    padding: 0 5px 10px 5px;
    .item-el {
        width: 208px;
        .img {
            width: 100%;
            height: 190px;
        }
        .title {
            height: 2.8em;
            line-height: 1.4em;
            margin: 12px 0;
            padding: 0 12px;
        }
        .content {
            padding: 8px 12px 15px 12px;
        }
        .ico-maintenance {
            width: 26px;
            height: 26px;
        }
    }
}
</style>